export enum Routes {
  Login = "/",
  LabellingTool = "/labelling-tool",
  AutomaticLabellingTest = "/labelling-test/:contentId",
  Dashboard = "/dashboard",
  ComponentLabellingTool = "/component-labelling-tool/:contentId",
  URl = "/urls",
  NewUsers = "/newusers",
  StartedSignup = "/newsignups",
  FinishedSignup = "/finishedsignup",
  NewInProgress = "/newinprogress",
  ImportFinished = "/newimportfinished",
  AllActiveUsers = "/allactiveuser",
  ContCraw = "/continuouscrawluser",
  ActiveNewWebsite = "/activenewwebsiteuser",
  ActiveFullCrawl = "/activefullcrawluser",
  ActiveImportFinished = "/activeimportfinisheduser",
  InactiveUser = "/inactiveuser",
  MarkedForDowngrade = "/markedfordowngrade",
  UserDetails = "/user/:userSlug",
  UserCounts = "/user-counts",
  ExpensiveSources = "/expensive-sources",
  AwaitingFeedback = "/awaiting-feedback",
  SourceTuning = "/source-tuning",
}
